<template>
    <div id="order-klinik">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vx-card class="mb-base" title="Group Test">
            <vue-form-generator
              tag="div"
              :schema="schema"
              :model="model"
              :options="formOptions"
              @model-updated="listen"
            ></vue-form-generator>
          </vx-card>
         <vx-card class="mb-base" title="Test/Pemeriksaan">
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2 flex">
               <vs-select
                 autocomplete
                 class="w-full"
                 name="test"
                 v-model="test"
                 placeholder="Cari Test/Pemeriksaan (Paket)"
                 @input-change="searchTest"
                 ref="test"
                 >
                 <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in listTest" />
               </vs-select>
             </div>
           </div>
           <div class="vx-row">
             <div class="vx-col w-full mt-2 mb-2">
                 <div class="vs-component vs-con-table stripe vs-table-primary">
                     <div class="con-tablex vs-table--content">
                         <div class="vs-con-tbody vs-table--tbody">
                             <table class="vs-table vs-table--tbody-table" noDataText="Tidak Ada Data" style="text-align:center; max-height:360px; overflow:scroll">
                                 <thead class="vs-table--thead">
                                     <th>No</th>
                                     <th>Kode</th>
                                     <th>Test/Pemeriksaan</th>
                                     <th><vs-button size="large" color="danger" type="flat" icon="swap_vert"></vs-button></th>
                                 </thead>

                                 <draggable v-model="listTestPatient" tag="tbody">
                                     <tr class="tr-values vs-table--tr tr-table-state-null" :key="indextr" v-for="(tr, indextr) in listTestPatient">
                                         <td class="td vs-table--td">
                                             {{indextr+1}}
                                         </td>
                                         <td class="td vs-table--td">
                                             {{(tr?tr.htCode:'')}}
                                         </td>                                         
                                         <td class="td vs-table--td">
                                             {{(tr?tr.name:'')}}
                                         </td>
                                         <td class="td vs-table--td">
                                             <vs-button radius style="cursor: pointer;" @click="acceptAlert(indextr)" color="danger" icon="delete"></vs-button>
                                         </td>
                                     </tr>
                                 </draggable>
                             </table>
                         </div>
                     </div>
                 </div>
             </div>
            </div>
         </vx-card>
        </div>
      </div>
      <div class="vx-col w-full" vs-justify="center">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-button
            class="mr-4 mb-4"
            color="danger"
            @click="$router.push('/pemeriksaan/grouptest/list')"
            >
            Batal
          </vs-button>
          <vs-button
            class="mr-4 mb-4"
            icon-pack="feather"
            color="#6488e4"
            @click="onConfirm"
            >
            Simpan
          </vs-button>
        </vs-row>
  		</div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import lab from "@/api/lab";
import master from "@/api/master";
import form from "@/api/form";
import tool from "@/tool/form_tool";
import moment from 'moment';
import draggable from 'vuedraggable';

export default {
  components: {
      Datepicker,
      draggable
  },
  data() {
    return {
			model: {},
			modelt: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
      },
      listTestPatient: [],
      listTest: [],
      loading: false,
      test: null,
      idxSelected: null,
    };
  },
  methods: {
		listen(newVal, schema) {
		},
    openConfirm(id) {
        this.idxSelected = id;
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptAlert
        });
    },
    acceptAlert(id) {
      this.listTestPatient.splice(id, 1);
    },
    onConfirm() {
        this.$vs.dialog({
            type: 'confirm',
            color: 'warning',
            title: `Konfirmasi`,
            text: 'Anda yakin untuk menyimpan data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.saveData
        })
    },
    saveData() {
      this.loading = true;
			let config = {
				headers: {
					"content-type": "application/json"
				}
      };

      let md = this.model;
      let ms = [];
      for (let i = 0; i < this.listTestPatient.length; i++) {
        let lp = this.listTestPatient[i];
        let me = { id: lp.id};
        ms.push(me);
      }
      md.measure = ms;

			lab.saveGroupTest(md, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di submit",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/pemeriksaan/grouptest/list"
						);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});

		},
    async getLabSection() {
      const prov = await lab.listBagianLab();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"labSection",
				prov.data.data
			);
    },
		async firstLoad() {
			const frm = await form.grouptest();
			this.schema.fields = frm.data.data[0].fields;
			let idx = this.$route.params.id;
			if (idx) {
				const xmodel = await lab.getGroupTest(idx);
        this.model = xmodel.data.data[0];
        this.listTestPatient = this.model.measure;
			} else {
				this.model = frm.data.data[0].model;
      }
      await this.getLabSection();
    },
    async searchTest(event) {
      this.listTest = [];
      if (event.target.value.length > 2) {
			    this.modelt["keyword"] = event.target.value;
          const frms = await lab.listMeasure(this.modelt);
          this.listTest = frms.data.data;
      }
    },
  },
  watch: {
    test: function(val) {
      let obj = this.lodash.find(this.listTest, o => {
        return o.id === val;
      });

      if (obj) {
        this.listTestPatient.push(obj);
      }
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.firstLoad();
  }
};
</script>
